<template>
    <div class="protocol_search_item">
        <div class="top_info">
            <div class="txt_cont">
                <div class="tit_label">
                    <span class="condition" :class="publicActive != 0 ? 'open' : null">{{publicActiveList[publicActive]}}</span>
<!--                    기획서 내용대로 "공정도"를 삭제-->
<!--                    <span class="label_color color_01" v-html="'공정도<em>|</em>'+uniqueNumber"></span>-->
                    <span v-if="uniqueNumber" class="label_color color_01" v-html="uniqueNumber"></span>
                    <span v-else class="label_color color_01" v-html="'공정도'"></span>
                    <span class="label_gray">{{`${fieldName.split(">").join(" / ")}`}}</span>
                </div>
                <a href="javascript:void(0);" @click="$emit('goToProcessDetail')" class="tit_link" v-html="processName">
                </a>
                <!--                현재 관리되고 있지 않은 데이터의 경우 빈 화면으로 퍼블리싱 적용 진행.​ -->
                <!--                영문 한글명 토글 구현시 사용.-->
                <!--                <p class="txt_info" v-html="processEngName"></p>-->
                <!--                키워드의 경우 아직 관리되고 있지 않음.-->
                <!--                <p class="txt_info">Skutterudite, CoSb3, 합성법, 열전소재, 에너지환경</p>-->
            </div>
            <div class="img_cont">
                <div class="img_box">
                    <a href="javascript:void(0);" @click="$emit('goToProcessDetail')">
                        <img :src="`data:image/jpeg;base64,${thumbnail}`" class="template"/>
                    </a>
                </div>
            </div>
        </div>
        <div class="bottom_info">
            <ul class="user_set">
                <li>{{lastEditDate}}</li>
                <li>책임작성자 : {{userName}}</li>
                <li v-if="collaborators?.length">공동작성자 :
                    <span
                            v-for="(collaborator,collaboratorKey) in collaborators"
                            :key="collaboratorKey"
                    >{{`${ (collaboratorKey != 0) ? (" ," + (!collaborator.userName ? collaborator.name : collaborator.userName)) 
                                                    : (!collaborator.userName ? collaborator.name : collaborator.userName)}`}}
                </span>
                </li>
            </ul>
            <ul class="btn_set">
                <li v-if="thisMyPage">
                    <a href="javascript:void(0);" 
                       v-if="thisMyPage" 
                       @click="$emit('goToProcessEditor');" 
                       class="editor_move_btn">에디터로 이동
                    </a>
                </li>
<!--                <li class="process">
                    <a href="javascript:void(0);" class="process_chart_btn"
                       @click="includedProtocolsActive = (!protocols?.length) ? (protocolCount == 0 ? false : true) : true">
                        포함된 프로토콜<span
                            class="count"><strong>{{`${ (!protocols?.length) ? (protocolCount == 0 ? 0 : protocolCount) : (protocols?.length) }`}}</strong>건</span>
                    </a>
                </li>-->
            </ul>
        </div>
        <IncludedProtocols
                :inProcessId="inProcessId"
                :lastEditDate="lastEditDate"
                :active="includedProtocolsActive"
                :publishingActive="publishingActive"
                :searchFlag="true"
                @goToDetail="goToDetail"
                @close="includedProtocolsActive = false"
                @goToProcessDetail="$emit('goToProcessDetail')"
        />
    </div>
</template>
<script>
    import IncludedProtocols from "@/components/modal/IncludedProtocols";

    export default {
        props: {
            processData: {
                type: Object, default: {}
            },
            thisMyPage: {
                type: Boolean, default: false
            },
            publishingActive: {
                type: Boolean, default: false
            },
        },
        components: {
            IncludedProtocols,
        },
        data() {
            return {
                inProcessId: 0,
                processName: '',
                processEngName: '',
                userName: '',
                companyName: '',
                createdDate: '',
                updatedDate: '',
                thumbnail: '',
                editerMode: false,
                fieldName: '',
                protocols: [],
                collaborators: [],
                accordionToggle: false,
                imageUrl: false,
                publicActive: null,
                protocolCount: 0,
                releaseDate: "",
                revisionDate: "",

                lastEditDate: "",
                includedProtocolsActive: false,
                uniqueNumber: null,

                publicActiveList: {
                    0: "비공개",
                    1: "일반회원 공개",
                    2: "위원,간사 공개",
                },
            }
        },
        computed: {},
        watch: {
            process(value) {
                this.init();
            }
        },
        mounted() {
            this.init();
            // 공개 데이터가 아님 (작성목록)
            if(this.thisMyPage) {
                // 최종 수정일 또는 생성일 화면에 보여줄 형식에 맞게 수정.
                if (!this.updatedDate) {
                    this.lastEditDate = this.createdDate.substring(0, 10).split('-').join('.');
                } else {
                    this.lastEditDate = this.updatedDate.substring(0, 10).split('-').join('.');
                }
            }else{
                if(!this.revisionDate){
                    this.lastEditDate = this.releaseDate.substring(0, 10).split('-').join('.');       
                }else{
                    this.lastEditDate = this.revisionDate.substring(0, 10).split('-').join('.');
                }
            }
        },
        methods: {
            init() {
                for (const item of Object.entries(this.processData)) {
                    switch (item[0]) {
                        case "processId" :
                            this["inProcessId"] = item[1];
                            break;
                        case "name" :
                            this["processName"] = item[1];
                            break;
                        default :
                            this[item[0]] = item[1];
                    }
                }
            },
            async viewImage(url) {
                /** 로그 등록 */
                await this.$wApi.trace.log({
                    type: 'PD', //PD 공정도, PR 프로토콜
                    code: 'R', //N 생성 M 수정 S 검색 R 조회
                    subCode: '01',
                    keyword: '',
                    result: 1,
                    ptlId: this.inProcessId
                });
                /** 로그 등록 */
                this.status.processViewerHandler.open(this.inProcessId, this.process.protocols);
            },
            linkClick(info) {
                this.Events['link-click'](info);
                this.$emit('link-click', info);
            },
            toggleListView() {
                this.Events['toggle-view'](info);
                this.$emit('toggle-view');
            },
            protocolClick(info) {
                this.Events['protocol-click'](info);
                this.$emit('protocol-click', info);
            },
            async coAuthInfo(info) {
                this.Events['coAuthor-info'](info);
            },
            async moveToProcessPage() {
                const processId = this.inProcessId;

                let path = '/process/editor';
                if (this.editerMode === false) {
                    window.alert('해당 문서의 수정권한을 가지고 있지 않습니다.')
                    return;
                }
                const {href} = this.$router.resolve({
                    path,
                    query: {
                        processId,
                        editorType: 'process',
                        protocolId: null
                    }
                });
                window.open(href, '_blank');
            },
            goToDetail(protocolId,viewMode,tabIndex){
                const beforeProcessId = this.inProcessId;
                this.$emit("goToProtocolDetail",protocolId,viewMode,tabIndex, beforeProcessId);
            }
        }

    }
</script>